import React, {useState} from 'react';
import "./App.scss";
import OnlinePvP from "../Games/OnlinePvP/OnlinePvP";
import LocalPvP from "../Games/LocalPvP/LocalPvP";

const App = () => {
    const [gameType, setGameType] = useState(LocalPvP.name);

    const switchGame = (gameType: string) => {
        console.log("Switching game", gameType);
        setGameType(gameType);
    };

    return (
        <section className="App">
            {gameType === LocalPvP.name ?
                <LocalPvP onSwitchGame={() => switchGame(OnlinePvP.name)}/> :
                <OnlinePvP onSwitchGame={() => switchGame(LocalPvP.name)}/>}
        </section>
    );
};

export default App;